import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

import CardsSlider from '../../components/cards/cards-slider';

const FilmsSliderLazyContainer = ({ selector, getContentAsync, title, headingHref }) => {
  const { i18n } = useTranslation();
  const content = useSelector(selector);
  const dispatch = useDispatch();
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    (async () => {
      try {
        if (!inView) return;
        unwrapResult(dispatch(getContentAsync()));
      } catch (e) {
        console.log(e);
      }
    })();
  }, [dispatch, getContentAsync, i18n.language, inView]);

  const updateContent = async () => {
    return await unwrapResult(await dispatch(getContentAsync()));
  };

  return (
    <div ref={ref}>
      <CardsSlider
        heading={title}
        headingHref={headingHref}
        isHeadingLink={true}
        items={content}
        updateVideoList={updateContent}
      />
    </div>
  );
};

export default FilmsSliderLazyContainer;

FilmsSliderLazyContainer.propTypes = {
  selector: PropTypes.func.isRequired,
  getContentAsync: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  headingHref: PropTypes.string.isRequired
};
